import React, { useState } from "react";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import {
  Paper,
  Typography,
  TextField,
  Box,
  Switch,
  FormControlLabel,
} from "@mui/material";

export default function WidgetEditor({ value, onChange }) {
  const [isJsonMode, setIsJsonMode] = useState(true);
  const [jsonString, setJsonString] = useState(
    value ? JSON.stringify(value, null, 2) : "",
  );
  const [error, setError] = useState(null);

  const placeholderExample = `{  
  "title": "My Widget",  
  "width": 300,  
  "height": 200,  
  "properties": {  
    "color": "#3f51b5",  
    "borderRadius": 4,  
    "showHeader": true  
  }  
}`;

  const handleJsonChange = e => {
    setJsonString(e.target.value);
    if (!e.target.value) {
      setError(null);
      onChange({});
      return;
    }
    try {
      const parsed = JSON.parse(e.target.value);
      setError(null);
      onChange(parsed);
    } catch (err) {
      setError("Invalid JSON format");
    }
  };

  const handleSwitchMode = () => {
    if (isJsonMode) {
      try {
        const parsed = jsonString ? JSON.parse(jsonString) : {};
        onChange(parsed);
        setError(null);
      } catch (err) {
        setError("Invalid JSON format, cannot switch to visual mode");
        return;
      }
    } else {
      setJsonString(JSON.stringify(value, null, 2));
    }
    setIsJsonMode(!isJsonMode);
  };

  const handleKeyDown = e => {
    if (e.key === "Tab") {
      e.preventDefault();
      const { selectionStart, selectionEnd } = e.target;
      const newValue =
        jsonString.substring(0, selectionStart) +
        "  " +
        jsonString.substring(selectionEnd);
      setJsonString(newValue);

      setTimeout(() => {
        e.target.selectionStart = e.target.selectionEnd = selectionStart + 2;
      }, 0);

      try {
        const parsed = JSON.parse(newValue);
        setError(null);
        onChange(parsed);
      } catch (err) {
        setError("Invalid JSON format");
      }
    }
  };

  return (
    <Paper elevation={3} style={{ padding: 16, marginBottom: 24 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Widget Property Editor</Typography>
        <FormControlLabel
          control={<Switch checked={isJsonMode} onChange={handleSwitchMode} />}
          label={isJsonMode ? "Text Mode" : "Visual Mode"}
        />
      </Box>

      {isJsonMode ? (
        <Box>
          <TextField
            fullWidth
            multiline
            rows={6}
            variant="outlined"
            value={jsonString}
            onChange={handleJsonChange}
            onKeyDown={handleKeyDown}
            error={!!error}
            helperText={error || "Enter valid JSON object"}
            placeholder={placeholderExample}
            InputProps={{
              style: { fontFamily: "monospace" },
            }}
          />
        </Box>
      ) : (
        <JsonView
          src={value || {}}
          onEdit={e => onChange(e.updated_src)}
          onAdd={e => onChange(e.updated_src)}
          onDelete={e => onChange(e.updated_src)}
          name={false}
          collapsed={false}
          enableClipboard={false}
          displayDataTypes={false}
          style={{ fontSize: 14 }}
        />
      )}
    </Paper>
  );
}
